import React, { useEffect } from 'react';
import { GameShowView as EvolutionGameShowView } from '../GameViews/Evolution/GameShowView';
import { BlackJackView as EvolutionBlackJackView } from '../GameViews/Evolution/BlackJackView';
import { RouletteView as EvolutionRouletteView } from '../GameViews/Evolution/RouletteView';
import { liveCasinoViewTypesEnum } from '../../../../../../shared/src/enums/live-casino-view-types.enum';
import { LiveCasinoService } from '../../../../../../shared/src/services/live-casino.service';

const getViewComponentsByProvider = (gameInfo, showGradient) => {
    if (LiveCasinoService.isEvolutionGame(gameInfo.subProvider)) {
        const maxResultShow = 6;

        // if gameInfo.results > maxResultShow then slice the result
        if (gameInfo.results && gameInfo.results.length > maxResultShow) {
            gameInfo.results = gameInfo.results.slice(0, maxResultShow);
        }

        return {
            [liveCasinoViewTypesEnum.GAME_SHOW]: (<EvolutionGameShowView
                results={gameInfo.results}
                showGradient={showGradient}
            />),
            [liveCasinoViewTypesEnum.BLACKJACK]: (<EvolutionBlackJackView
                seatsTaken={gameInfo.seatsTaken}
                betBehind={gameInfo.betBehind}
                showGradient={showGradient}
            />),
            [liveCasinoViewTypesEnum.ROULETTE]: (<EvolutionRouletteView
                results={gameInfo.results}
                showGradient={showGradient}
            />),
        };
    }
};

export const GameType = ({ gameInfo, showGradient }) => {
    const gameComponents = getViewComponentsByProvider(gameInfo, showGradient);
    const componentToRender = gameComponents[gameInfo.viewType];

    useEffect(() => {
        if (!componentToRender) {
            showGradient(false);
        }
    }, [gameInfo]);

    if (!componentToRender) {
        return null;
    }

    return <div className="live-casino__game-type game-type">{componentToRender}</div>;
};
